import type { ShopRepository } from "../../repositories/shop/shop-repository";
import { AppError } from "../../../shared/utils/error-handler";
import type { ShopDetailDto } from "../../types/shop";

export class ShopUseCase {
  constructor(private shopRepository: ShopRepository) {}

  async getShopHome(): Promise<ShopDetailDto> {
    try {
      return await this.shopRepository.getShopHome();
    } catch (error) {
      throw new AppError(
        String(error) || "쇼핑몰 정보를 불러오지 못했습니다.",
        "SHOP_HOME_GET_FAILED",
        error,
      );
    }
  }

  async getShopHomeById(shopId: number): Promise<ShopDetailDto> {
    try {
      return await this.shopRepository.getShopHomeById(shopId);
    } catch (error) {
      throw new AppError(
        String(error) ||
          "주어진 아이디에 해당하는 쇼핑몰 정보를 불러오지 못했습니다.",
        "SHOP_HOME_GET_FAILED",
        error,
      );
    }
  }
}
